import { subTab } from "@/components/settings/subscription/subscription-tabs.ts";
import { z } from "zod";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/dashboard/subscription")({
	validateSearch: z.object({
		// .catch(): a hand-tampered ?tab=xyz degrades to the default tab rather than
		// the route error boundary, matching every other tab surface.
		tab: subTab.optional().catch(undefined),
	}),
	beforeLoad: ({ search }) => {
		throw redirect({ to: "/settings/org/subscription", search });
	},
});
